import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';
const saveAuthenticatedUserDone  = (_,{payload}) => {
  return {
    user: payload.user,
  };
}

const fetchAuthenticatedUserDone = (state, { payload }) => {
  return {
    ...state,
    user: payload,
  };
};

const savePropertyManagerDetails = (state, {payload}) => {
  return {
    ...state,
    propertyManagerDetails: payload
  };
}

const clearPropertyManagerDetails = (state) => {
  return {
    ...state,
    propertyManagerDetails: {}
  };
}
const savePropertyManagerCalendlyLinkDone = (state, {payload}) => {
  return {
    ...state,
    propertyManagerDetails: {
      ...state.propertyManagerDetails,
      ...payload
    }
  };
}

const initialState = {};

export default createReducer(initialState, {
  [TYPES.AUTH_SIGN_IN_DONE]:saveAuthenticatedUserDone,
  [TYPES.FETCH_AUTHENTICATED_USER_DONE]: fetchAuthenticatedUserDone,
  [TYPES.PROPERTY_MANAGER_DETAILS_DONE]: savePropertyManagerDetails,
  [TYPES.PROPERTY_MANAGER_CALENDLY_DONE]: savePropertyManagerCalendlyLinkDone,
  [TYPES.CLEAR_PROPERTY_MANAGER_DETAILS]: clearPropertyManagerDetails,

});
